import { useEffect } from 'react';

import { Button, Typography, julo } from '@julo-ui/react';

import TncContent from './TncContent';
import ArrowLeft from '@new-components/shapes/ArrowLeft';

import useGlobalState from 'actions';

import { tncDialog } from '../styles';

interface Props {
  onAcceptTnc: () => void;
  onRejectTnc: () => void;
}

const TncDialog = (props: Props) => {
  const { onAcceptTnc, onRejectTnc } = props;
  const [, globalActions] = useGlobalState();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  const handleClose = () => {
    globalActions.openTnCDialog('open', false);
    globalActions.setState('sayaTelah', false);
    globalActions.setState('sayaTelahCheck', false);
    globalActions.setState('sayaTelah', false);
    onRejectTnc();
  };

  const handleAccept = () => {
    globalActions.openTnCDialog('open', false);
    globalActions.setState('sayaTelahCheck', true);
    onAcceptTnc();
  };

  return (
    <julo.div className={tncDialog}>
      <julo.div className='header'>
        <julo.div className='back-btn'>
          <ArrowLeft onClick={handleClose} />
        </julo.div>
        <Typography type='body' bold>
          Syarat Ketentuan
        </Typography>
      </julo.div>
      <TncContent />
      <julo.div className='actions'>
        <Button variant='secondary' onClick={handleClose}>
          Batal
        </Button>
        <Button onClick={handleAccept}>Lanjut</Button>
      </julo.div>
    </julo.div>
  );
};

export default TncDialog;
